import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { LocalDeviceDetectorService } from 'dmmp-services'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-content-rows',
  templateUrl: './content-rows.component.html'
})
export class ContentRowsComponent implements OnInit {

  @Input() colItem
  @Input() identifier
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() menuEmitter = new EventEmitter()
  @Output() contentEmitter = new EventEmitter()
  @Output() externalLink = new EventEmitter()
  @Output() hoverEmitter = new EventEmitter()
  @Input() module
  @Input() menu
  medias : MediaInterface[] = [
    {style: 'max_650x650', media: '(min-width: 326px)'},
    {style: 'max_325x325', media: '(max-width: 325px)'},
  ]

  constructor(public localDeviceDetector: LocalDeviceDetectorService) { }

  ngOnInit(): void {
  }

  buttonContentEmit(relatedContent) {
    if (relatedContent.length > 0) {
      this.contentEmitter.emit(relatedContent[0])
      this.closeRelatedContentButtons(relatedContent[0])
    }
  }

  closeRelatedContentButtons(currentRelatedContent) {
    this.colItem.items_column.forEach(itemColum => {
      if (itemColum.related_module.length > 0) {
        if (itemColum.identifier === 'button_content' && itemColum.related_module[0].title !== currentRelatedContent.title) {
          itemColum.active = false
        }
      }
    })
  }

  clickActionEmitter(itemMenuTo) {
    this.menu.forEach(itemMenu => {
      if (itemMenuTo !== itemMenu) {
        itemMenu.data.active = false
      }
    })
    this.menuEmitter.emit(itemMenuTo)
  }

}
